import { useAppStore, useCmsStore } from "@/components/AppHooks";
import { TDreamerCocktailDetailProps } from "./type";
import { DdpVideo } from "@/components/shared/DdpVideo";
import { DdpImage } from "@/components/shared/DdpImage";
import { DdpCta } from "@/components/shared/DdpCta";
import { IconFollow } from "@/components/icon/tanqueray";
import { TanquerayCocktailList } from "@/components/shared/Tanqueray/TanqueryCocktailList";
import { useEffect, useState } from "react";
import { getCocktailInfo } from "@/shared/utils";
import { tracking } from "@/shared/tracking";
import { TanquerayBack } from "@/components/shared/Tanqueray/TanquerayBack";

export function CocktailDreamerDetailTanqueray(props: TDreamerCocktailDetailProps) {
    const { dreamerCocktail, searchParams: {
        cocktailId
    } } = props
    const pageDreamerCocktailDetail = dreamerCocktail.find((item) => item.iDDreamerCocktail.toLocaleLowerCase() === cocktailId?.toLowerCase())
    const [descriptionBig, setDescriptionBig] = useState<string>('')
    useEffect(() => {
        if (!cocktailId) return
        getCocktailInfo([cocktailId], 'secondCocktailList').then((res) => {
            setDescriptionBig(res[0].cocktailDescriptionBig)
            tracking({
                "event": "custom_event",
                "event_name": "view_recipe",
                "recipe_id": cocktailId,
                "recipe_name": res[0].cocktailTitle,
                "brand": res[0].brandName
            })
        })
    }, [cocktailId])
    const { results } = useAppStore()!
    const { storeConfig:{
        newTabForProductDetail
    } } = useCmsStore()!
    const linkProps = newTabForProductDetail ? { target: '_blank' } : {target: ''};
    return <div className="page-dreamer-cocktail-detail">{
        pageDreamerCocktailDetail && <>
            <div className="hero-media-container">
                {
                    pageDreamerCocktailDetail && <DdpVideo className="hero-media" video={pageDreamerCocktailDetail.heroMediaDreamerCocktail[0]} hasButton autoPlay once />
                }
            </div>
            <div className="basic-info-container">
                <TanquerayBack />
                <div className="title">{pageDreamerCocktailDetail.heroTitleDreamerCocktail}</div>
                <div className="byline-wrapper" >
                    <div className="dreamt-byline" dangerouslySetInnerHTML={{ __html: pageDreamerCocktailDetail.dreamtBy }}></div>
                    <div className="carfted-byline" dangerouslySetInnerHTML={{ __html: pageDreamerCocktailDetail.craftedBy }}></div>
                </div>
                <div className="cocktail-desc" dangerouslySetInnerHTML={{ __html: descriptionBig }}></div>
            </div>
            <div className="crafited-user-container">

                <div className="crafited-user-content-wrapper">
                    <DdpImage className="user-head" image={pageDreamerCocktailDetail.imageCraftIntro} />
                    <div className="user-basic-info">
                        <div className="title">{pageDreamerCocktailDetail.titleCraftIntro}</div>
                        <div className="desc" dangerouslySetInnerHTML={{ __html: pageDreamerCocktailDetail.descriptionCraftIntro }}></div>
                        <div className="cta-wrapper">
                            <DdpCta className="follow black nohover" cta={pageDreamerCocktailDetail.followCTACraftIntro} >
                                <IconFollow />
                            </DdpCta>
                            <DdpCta className="make-the-dream" cta={pageDreamerCocktailDetail.makeTheDreamCTACraftIntro} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="flavour-notes-container">
                <div className="title">{props.titleFlavourNotes}</div>
                <div className="notes-media-container">
                    <DdpImage className="notes-img" image={pageDreamerCocktailDetail.imageFlavourNotes} />
                </div>
                <div className="quotation" dangerouslySetInnerHTML={{ __html: pageDreamerCocktailDetail.quotationFlavourNotes }}></div>
                <div className="author" dangerouslySetInnerHTML={{ __html: pageDreamerCocktailDetail.authorFlavourNotes }}></div>
            </div>

            <div className="nten-product-container">
                <DdpImage className="nten-image" image={props.bottleImageNten} />
                <div className="title">{props.titleNten}</div>
                <div className="desc" dangerouslySetInnerHTML={{ __html: props.descriptionNten }}></div>
                <div className="nten-cta-wrapper">
                    <DdpCta className="cta-buy-now black" cta={props.cTANten} {...linkProps} />
                    <DdpCta className="start-dreaming-again " cta={props.startDreamingAgain} />
                </div>

            </div>
            <div className={`more-dreamy-cocktail-container ${results && results?.cocktailRecommendations.length > 0 ? '' : '!pb-0'}`}>
                {
                    results && results?.cocktailRecommendations.length > 0 && <>
                        <div className="title">{props.moreCocktails}</div>
                        <TanquerayCocktailList cta={props.discoverCTA} cocktailList={results.cocktailRecommendations.slice(0, 3)} matchText={props.matchText} />
                    </>}
            </div>


        </>
    }


    </div>
}